import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ee423f5e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./pagination.less?vue&type=style&index=0&id=ee423f5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee423f5e",
  null
  
)

export default component.exports